import { HttpParams } from '@angular/common/http';

const isEmptyArray = (data: unknown): boolean => Array.isArray(data) && data.length === 0;

const isEmptyParam = (data: unknown): boolean =>
    isEmptyArray(data) || data === null || data === '' || typeof data === 'undefined';

export const getHttpParamsFromObject = <T extends Record<string, any>>(params?: T): HttpParams => {
    if (!params) {
        return new HttpParams();
    }

    const preparedParams: { [key: string]: string } = {};

    Object.keys(params).forEach((keyName: string) => {
        if (!isEmptyParam(params[keyName])) {
            preparedParams[keyName] = Array.isArray(params[keyName])
                ? params[keyName].join(',')
                : params[keyName].toString();
        }
    });

    return new HttpParams({ fromObject: preparedParams });
};
